import React from 'react';
import ReactTable from 'react-table';
import { withRouter  } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import { usersActions } from '../../../store/users';

import { Panel, PanelHeader } from '../../../components/admin/panel/panel';
import 'react-table/react-table.css';
import '../../../assets/admin/css/custom.css';

class Users extends React.Component {

    constructor(props) {
        super(props);

        // https://www.npmjs.com/package/react-table#example
        this.defaultSorted = [
            {
                id: "time",
                desc: true
            }
        ];
        this.tableColumns = [
            {
                Header: "인증",
                columns: [
                    {
                        Header: '아이디',
                        accessor: 'userName'
                    },
                    {
                        Header: '권한',
                        accessor: 'role'
                    }
                ]
            },
            {
                Header: "정보",
                columns: [
                    {
                        Header: '이름',
                        accessor: 'name'
                    },
                    {
                        Header: '이메일',
                        accessor: 'email',
                    }
                ]
            },
            {
                Header: "상태",
                columns: [
                    {
                        id: 'time',
                        Header: '등록일',
                        accessor: d => moment(d.time).format("YYYY-MM-DD hh:mm:ss")
                    },
                    {
                        filterable: false,
                        Header: '',
                        accessor: 'userId',
                        Cell: row => (
                            // if (window.confirm('Are you sure you wish to delete this item?')) this.deleteItem(e)
                            <div className="text-center">
                                <button onClick={ event => { if (window.confirm('정말로 삭제하시겠습니까?')) this.onClickDelete(event, row.value) }} className="btn btn-grey btn-xs rounded-0 m-r-5 m-t-minus-5">삭제</button>
                                <button onClick={event => this.onClickUpdate(event, row.value)} className="btn btn-inverse btn-xs rounded-0 m-r-5 m-t-minus-5">수정</button>
                            </div>
                        )
                    }
                ]
            }
        ]
    }

    componentDidMount() {
        this.props.getUsers();
    }

    onClickCreate = (event) => {
        event.preventDefault();
        this.props.history.push('/admin/users/create');
    }

    onClickUpdate = (event) => {
        event.preventDefault();
        console.log('update');
    }

    onClickDelete = (event, id) => {
        event.preventDefault();
        if (id) this.props.deleteUser(id);
    }

    render() {

        if (this.props.users.length === 0) return null;

        //console.log(this.props.users);

        return (
            <div>
                <div className="page-header">
                    <button onClick={event => this.onClickCreate(event)} className="btn btn-danger btn-sm"><i className="fa fa-plus"></i> 신규등록</button>
                </div>
                <Panel>
                    <PanelHeader>관리자 계정</PanelHeader>
                    <ReactTable filterable data={this.props.users} columns={this.tableColumns} defaultPageSize={10} defaultSorted={this.defaultSorted} className="-highlight" />
                </Panel>
            </div>
        )
    }
}

export default connect(
    state => state.users,
    dispatch => bindActionCreators({ ...usersActions }, dispatch)
)(withRouter(Users));


// WEBPACK FOOTER //
// ./src/pages/admin/users/index.js